// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import PhotoPreviewController from "./photo_preview_controller"
application.register("photo-preview", PhotoPreviewController)
